import { Divider, Link, List, ListItem, Paper, Typography } from '@mui/material';
import React from 'react';
export const SectionWithLinks = (props) => {
    return (React.createElement(Paper, { elevation: 4, sx: { mb: 2 } },
        React.createElement(Typography, { variant: 'h6', pb: 1, pt: 1, pl: 4, "data-test": 'section-title' }, props.title),
        React.createElement(Divider, null),
        React.createElement(List, { sx: { p: 3, pl: { sm: 4, lg: 8 } } }, props.links.map(({ label, href, onClick, 'data-test': dataTest }) => (React.createElement(ListItem, { key: label, sx: { width: { xs: 1, sm: 1 / 2, xl: 1 / 4 }, display: 'inline-flex' } },
            React.createElement(Link, { href: href, onClick: (event) => {
                    event.preventDefault();
                    onClick(href);
                }, "data-test": dataTest },
                React.createElement(Typography, { fontWeight: '500' },
                    "\u2022 ",
                    label))))))));
};
